export class SaleTransactionModel {
  transactionSurrKey: number;
  createDate: Date;
  transactionCode: string;
  companyName: string;
  packageName: string;
  amount: number;
  projectAmount: number;
  paymentMethod: number;
  userName: string;
  userPhone: string;
  userEmail: string;
  paidDate: Date;
  orderInvoiceSurrKey?: number;
  isInvoiceActive: boolean;
  refOrder?: string;
  orderStatus: number;
}

export class SaleTransactionListModel {
  itemList: Array<SaleTransactionModel>;
  pageNumber: number;
  pageSize: number;
  totalItemCount: number;
  totalPageCount: number;
}

export class SaleTransactionListQueryModel {
  textSearch?: string;
  pageNumber: number;
  pageSize: number;
  sortColumn?: string;
  sortByDesc: boolean;
  status?: number;
  startDate?: Date;
  endDate?: Date;
}
